<template>

    <a-modal class="invitation"
             centered
             :width="976"
             :visible="visible"
             @cancel="$emit('cancel')"
             :maskClosable="false"
             :footer="null"
             :destroyOnClose="true"
             :confirmLoading="modalLoading">
        <div class="ydtc">
            <a href="#" class="yd-close" @click="onSkip">
                <img src="../../img/yd-close.png" >
            </a>
            <div style="text-align: center;padding-left: 224px;">
                <img  src="../../img/tcbt.png" >
            </div>

            <div class="yd-text">
                <p>感谢您注册成为广东志正招标有限公司的供应商！首次注册请选择您的单位性质：</p>
            </div>

            <div class="type-gys mb-5">
                <a id="btn1" href="#" class="type-gys-item"  @click="selectValue('2')" :class="supplierType === '2' ? 'activeClass' : ''" >
                    <img src="../../img/fr.png" >
                    <span>法人供应商</span>
                </a>
                <a id="btn2" href="#" class="type-gys-item" @click="selectValue('1')" :class="supplierType === '1' ? 'activeClass' : ''">
                    <img src="../../img/gth.png" >
                    <span>个体户供应商</span>
                </a>
                <a id="btn3" href="#" class="type-gys-item" @click="selectValue('0')" :class="supplierType === '0' ? 'activeClass' : ''">
                    <img src="../../img/zrr.png" >
                    <span>自然人供应商</span>
                </a>
            </div>
            <div class="text-center color-red mt-5" v-if="supplierType === '1' || supplierType === '2'">法人供应商和个体户供应商需要进行认证后才能报名。</div>
            <div class="yd-btn">
                    <button type="button" @click="onSkip" v-if="(supplierType === '1' || supplierType === '2')">下次再说</button>
                    <button class="main" style="margin-left: 90px" type="button" @click="onSkip" v-if="supplierType === '0'">确定</button>
                    <button class="main" type="button" @click="onCertificate"  v-if="(supplierType === '1' || supplierType === '2')">立即认证</button>
            </div>
        </div>
    </a-modal>

</template>

<script>
    import qs from 'qs'

    export default {
        name: 'AccountTip',
        components: {
        },
        created() {
        },
        props: {
            visible: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                packs:'',
                modalLoading: false,
                subjectList: [],
                inviteInfo: '',
                supplierType: '',
                btnStyle:{
                    border: '1px solid #a3998d',
                    backgroundColor: '#f0edeb'
                },
                unBtnStyle:{

                }
            }
        },
        methods: {
            initData(id) {
                let that = this
                this.$http.get('/api/v1/supplier/project/getInvitedDetails.json?id='+id).then(function (res) {
                    that.inviteInfo =  res.result
                });
            },
            announceDetails() {
                // this.$router.push({path: '/project/announce?id=' + this.inviteInfo.announceId })
                let routeIndex = this.$router.resolve({
                    path: '/project/announce?id=' + this.inviteInfo.announceId
                })
                window.open(routeIndex.href, '_blank')
            },
            selectValue(value){
              this.supplierType = value
            },
            onSkip() {
                this.$emit('cancel')
            },
            onCertificate() {
                if (!this.supplierType){
                    this.$message.warn("请选择供应商类型")
                }else if (this.supplierType === '0') {
                    // this.$emit('cancel')
                    return
                }else if (this.supplierType === '1') {
                    this.$router.push({path: '/enterprise/PersonCertificationIndex'});
                }else if (this.supplierType === '2'){
                    this.$router.push({path: '/enterprise/LegalCertificationIndex'});
                }
            }
        }
    };
</script>
<style lang="less" scoped>

    /deep/ .ant-modal-content {
        position: relative;
         background: none;
        background-clip: padding-box;
        border: 0;
        border-radius: 4px;
         box-shadow: none;
        pointer-events: auto;
    }




    a{
        text-decoration: none;
        color: #333;
    }
    li{
        list-style: none;
    }
    .w{
        width: 1400px;
        margin: 0 auto;
    }
    .clear:after{
        content: "";
        display: block;
        clear: both;
    }
    body{
        width: 100%;
        height: 100%;
        background-size: 100%;
    }
    input{
        outline: none;
        border: 0;
        background: none;
    }
    button{
        border: none;
        outline: none;
        color: #fff;
    }
    table{
        border-collapse: collapse;
    }

    .main{
        width: 100%;
        height: 100%;
    }
    .mask{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,.4);
    }
    .ydtc{
        position: relative;
        width: 976px;
        height: 570px;
        padding: 80px 100px;
        background: url(../../img/account_tip_bg.png) no-repeat;
        text-align: center;
    }
    .yd-close{
        position: absolute;
        right: -24px;
        top: -10px;
        opacity: .7;
    }
    .yd-close:hover{
        opacity: 1;
    }
    .yd-text{
        text-align: left;
        font-size: 20px;
        font-weight: 400;
        color: #506a77;
        margin-top: 20px;
    }
    .type-gys{
        display: flex;
        justify-content: space-around;
        margin-top: 40px;
    }
    .type-gys-item{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 146px;
        height: 146px;
    }
    .type-gys-item:hover{
        border: 1px solid #a3998d;
        background-color: #f0edeb;
    }
    /*.type-gys-item:visited{*/
    /*    border: 1px solid #a3998d;*/
    /*    background-color: #f0edeb;*/
    /*}*/
    .type-gys-item span{
        margin-top: 12px;
    }

    .yd-btn{
        display: flex;
        justify-content: space-between;
        width: 320px;
        margin: auto;
        padding-top: 37px;
    }
    .yd-btn button{
        width: 132px;
        height: 36px;
        color: #506a77;
        font-size: 16px;
        border:1px solid #e6e6e6;
        cursor: pointer;
        background-color: #f0edeb;
        border-radius: 4px;
    }
    .yd-btn button.main{
        color: #fff;
        font-size: 16px;
        background: #1890ff;
        border:1px solid #1890ff;
        cursor: pointer;
    }
    .yd-btn .next-btn{
        opacity: .65;
        background-color: rgba(0,0,0,0);
    }
    .activeClass{
        border: 1px solid #a3998d;
        background-color: #f0edeb;
    }
</style>
